import axios from 'axios'
import { defineNuxtPlugin } from '#app'
import { createApiService } from '@/api'
import { Mode } from '@/types/environment'
import { getApiUrlWithDynamicDomain } from '~/utils/getApiUrlWithDynamicDomain'

export default defineNuxtPlugin(({ $config }) => {
  const { API_BASE_URL, BRAND_UUID, MODE, VARITI_TOKEN } = $config.public
  const { host } = useRequestURL()

  const BASE_URL = getApiUrlWithDynamicDomain(API_BASE_URL, host, MODE as Mode)

  const baseURL = `${BASE_URL}/v3/${BRAND_UUID}/`

  // Нужно для API без города
  const hostname = Mode.DEVELOPMENT === MODE ? 'frfrstaging.ru' : host

  const $axios = axios.create({
    baseURL,
    xsrfCookieName: 'csrftoken2',
    xsrfHeaderName: 'X-CSRFTOKEN',
    withCredentials: true,
    headers: { ...getAxiosGlobalHeader({ varitiToken: VARITI_TOKEN }) },
  })

  const { $sentryCaptureException } = useNuxtApp()

  // мокаем sentry для axios
  const sentry = {
    captureException: (error: unknown) => $sentryCaptureException(error),
  }

  const apiService = createApiService({
    sentry,
    axios: $axios,
    hostname,
  })

  return {
    provide: {
      apiService,
      axios: $axios,
    },
  }
})
